export default {
    campaignPaymentList: [],
    campaignPaymentListCount: 0,
    campaignPayment: {}
}